import React, {useRef, useState } from 'react'
import { OverlayPanel } from 'primereact/overlaypanel';
import ProClientDetails from './ProClientDetails';
import { useClientService } from '../../hooks/useClientService';
import { Dependent,  DependentReservation} from '../../constants/ProIcons'
import _ from 'lodash'


const ProClient = ({data, clickable = true, image= false})=>{
    const op = useRef(null);
    const [clientData, setClientData] = useState(null)  
    const {GetClientDetails} = useClientService();

    const handleClick = async (e, assignmentId)=>{
        if(clickable){
            const data = await GetClientDetails(assignmentId) 
            setClientData(data);   
            data && op.current && op.current.toggle(e);      
            
        }
    }
    
    const clientNameStyle = data.latestAssignment?{position: 'relative' } : {position: 'relative', fontStyle:"italic", color:"#808080"}
    const clientOpacityClass = data.latestAssignment? '' : 'icon-opacity-low'
   if(_.get(data.occupantType, "code") === "CLIENT")       
        return <div>

            <div>
                <i className ={_.isEqual(data.occupancyStatus, "OCCUPIED")?"fa fa-user " + clientOpacityClass: "fal fa-user "+clientOpacityClass} onClick={(e)=>handleClick(e, data.assignmentId)} aria-hidden="true" style={{ color: '#34436d', fontSize: 15, position: 'relative', marginLeft:"20px", cursor:'pointer' }}>               
                </i>
                <span className='tree-node cursor-pointer' onClick={(e)=>handleClick(e, data.assignmentId)} style={clientNameStyle}>{`${data.client.lastName}, ${data.client.firstName} (${data.client.number})`}
                    {_.get(data, "reservationStatus") && _.isEqual(data.reservationStatus, "RESERVED") && _.isEqual(data.occupancyStatus, "UNOCCUPIED")&& <span  style={{ fontSize: 11, color:"#808080", position: 'relative' }}> - Reserved</span>}</span>
            </div>
            {clickable && clientData && <OverlayPanel ref={op} dismissable showCloseIcon id={`${data.assignmentId}`} style={{width: '550px'}}>
                <ProClientDetails clientData={clientData}/>
             </OverlayPanel>}
        </div> 
    if(_.get(data.occupantType, "code") === "DEPENDENT")      
        return  <div>
                <div>
                    <i className ={"fas " +clientOpacityClass} aria-hidden="true" style={{ color: '#579800', fontSize: 12, position: 'relative', marginLeft:"20px", cursor:'pointer'}} onClick={(e)=>handleClick(e, data.assignmentId)}>  
                        {_.isEqual(data.occupancyStatus, "OCCUPIED")?<Dependent/> : <DependentReservation/> }          

                    </i> 
                    <span className='tree-node cursor-pointer' onClick={(e)=>handleClick(e, data.assignmentId)} style={{...clientNameStyle, top: "-2px" }}>{`${data.client.dependentName} (${data.client.lastName}, ${data.client.firstName} #${data.client.number})`}
                        { _.get(data, "reservationStatus") && _.isEqual(data.reservationStatus, "RESERVED")  && _.isEqual(data.occupancyStatus, "UNOCCUPIED")&& <span  style={{ fontSize: 11,color:"#808080", position: 'relative' }}> - Reserved</span>}</span>
                </div>

               {clickable && clientData && <OverlayPanel ref={op} dismissable showCloseIcon id={`${data.assignmentId}`} style={{width: '450px'}}>
                    <ProClientDetails clientData={clientData}/>
                </OverlayPanel>}
            </div>

}

export default ProClient;